export default function resolveCertificationStatus(status) {
  if (status === 'PUBLIC') return { variant: 'success', text: 'Publiczny' }
  if (status === 'NON_PUBLIC') return { variant: 'secondary', text: 'Niepubliczny' }
  return { variant: 'light', text: 'Nieznany status' }
}
